import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <rect x='10.5' y='3' width='3' height='3.27273' rx='1.5' />
            <rect x='10.5' y='7.90906' width='3' height='13.0909' rx='1.5' />
        </SvgIcon>
    );
});
